export enum DataImportEntityEnum {
  GOODS = 'goods',
  SERVICES = 'services',
  DIGITAL_PRODUCTS = 'digital-products',
  CORPORATE_PARTNERS = 'corporate-partners',
  PRIVATE_PARTNERS = 'private-partners',
  PRICES = 'prices',
  STOCK_STATUS = 'stock-status',
  PAYMENTS = 'payments',
  PARTNER_ACCOUNT = 'PARTNER',
}
